<template>
    <div class="project-manager-invite page-invite">
        <data-form title="Invite Project Manager"
                   tag="project-manager-invite"
                   save-button-label="Send"
                   :field-model="fieldModel"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   submit-success-message="Invite sent"
                   submit-error-message="Error inviting user"
                   :submit-success-route="'/'">
        </data-form>
    </div>
</template>

<script>
import { required, email as emailValidator } from 'vuelidate/lib/validators'
import Agency from '@/models/Agency'
import Validation from "@/providers/Validation";

export default {
    name: 'ProjectManagerInvite',
    data () {
        return {
            fieldModel: {
                fields: {
                    email: {
                        label: 'Email',
                        type: 'text',
                        validations: {
                            required,
                            email: v => v ? emailValidator(v.toLowerCase()) : true,
                            email_unique: Validation.validateEmailUnique
                        },
                        invalidFeedback: {
                            email_unique: 'This email is already a user in The Yard!'
                        }
                    },
                    agency_id: {
                        label: 'Agency',
                        type: 'select',
                        options: [],
                        async loadOptions () {
                            Agency.loadAgencyOptions(this)
                        },
                    },
                }
            },
            fieldGroups: [['email', 'agency_id']],
        }
    },
    methods: {
        onSubmit (modelInstance) {
            return this.$api.inviteProjectManager(this, modelInstance)
        }
    }
}
</script>
